import Vue from "vue";

/* Import New myWidgets components */

Vue.component("b2bregistration", () => import("./myWidgets/app/components/customer/B2bRegistration.vue"));
Vue.component("basket-elements", () => import("./myWidgets/app/components/basket/BasketElements.vue"));
Vue.component("basket-slots", () => import("./myWidgets/app/components/basket/BasketSlots.vue"));
Vue.component("inline-step-by-step-navigation", () => import("./myWidgets/app/components/category/InlineStepByStepNavigation.vue"));
Vue.component("irri-login-handler", () => import("./myWidgets/app/components/customer/login/UserLoginHandler.vue"));

// import ".myWidgets/app/components/pageDesign/MobileNavigation";

/* Import Overriden Ceres components. */
// All overriden Ceres components are placed directly to base.js (SSR Off) and app.js(SSR On)
